import React from 'react';

const NoPage = () => {
  return <div>Something went wrong.</div>;
};

export default NoPage;
